import { toReset } from 'react-async-client';
import { defaultSort } from 'constants/defaultSorts';

import {
    SET_APPROVAL_PERSON_LIST_SORT,
    SET_APPROVAL_PROJECT_LIST_SORT,
    SET_PROJECT_LIST_SORT,
    SET_WORKSHEET_LIST_SORT,
    SET_REQUEST_LIST_SORT,
    SET_NOTDONE_LIST_SORT,

    SET_PROJECT_MASS_LIST_SORT,
    SET_WORKSHEET_MASS_LIST_SORT,

    GET_REQUEST_LIST,
    GET_APPROVAL_PROJECT_LIST,
    GET_APPROVAL_PERSON_LIST,
    GET_PROJECT_LIST,
    GET_WORKSHEET_LIST,
    GET_NOTDONE_LIST,
    GET_PROJECT_MASS_LIST,
    GET_WORKSHEET_MASS_LIST
} from 'constants/actionTypes';

const createSortReducer = (SET_SORT, GET_LIST, defaultState = defaultSort) =>
    (state = defaultState, action) => {
        switch(action.type) {
            case SET_SORT:
                return action.payload || defaultState;
            case toReset(GET_LIST):
                return defaultState;
            default:
                return state;
        }
    };

export const requestListSortReducer = createSortReducer(
    SET_REQUEST_LIST_SORT,
    GET_REQUEST_LIST
);

export const approvalPersonListSortReducer = createSortReducer(
    SET_APPROVAL_PERSON_LIST_SORT,
    GET_APPROVAL_PERSON_LIST
);

export const approvalProjectListSortReducer = createSortReducer(
    SET_APPROVAL_PROJECT_LIST_SORT,
    GET_APPROVAL_PROJECT_LIST
);

export const projectListSortReducer = createSortReducer(
    SET_PROJECT_LIST_SORT,
    GET_PROJECT_LIST
);

export const worksheetListSortReducer = createSortReducer(
    SET_WORKSHEET_LIST_SORT,
    GET_WORKSHEET_LIST
);

export const notDoneSortReducer = createSortReducer(
    SET_NOTDONE_LIST_SORT,
    GET_NOTDONE_LIST,
    {},
);

export const projectMassListSortReducer = createSortReducer(
    SET_PROJECT_MASS_LIST_SORT,
    GET_PROJECT_MASS_LIST
);

export const worksheetMassListSortReducer = createSortReducer(
    SET_WORKSHEET_MASS_LIST_SORT,
    GET_WORKSHEET_MASS_LIST
);
